import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModuleService } from '../../services/module.service';
import { AddNewUtilityModel, ModuleDetails } from '../../models/module.model';

@Component({
  selector: 'app-workflow-configuration',
  templateUrl: './workflow-configuration.component.html',
  styleUrl: './workflow-configuration.component.scss',
  standalone: false
})
export class WorkflowConfigurationComponent implements OnInit {

  data: ModuleDetails[] = [];

  constructor(private router: Router, private route: ActivatedRoute, private moduleService: ModuleService) {}

  ngOnInit() {
    this.getAll();
  }

  goToAddNewModule() {
    this.router.navigate(['../add-new-workflow'], { relativeTo: this.route });
  }

  private getAll() {
    this.moduleService.getAll().subscribe({
      next: (response) => {
        this.data = response?.body.data;
       }
    })
    }

    handleAddNew() {
    }
}
